import ThuisbehandelingDvt from "../../../../src/client/katnh/widgets/ThuisbehandelingDvt.js";
import * as React from 'react';
export default {
  ThuisbehandelingDvt,
  React
};